export const GET_PLCC_BANNER_HTML = 'GET_PLCC_BANNER_HTML';
export const SET_PLCC_BANNER_HTML = 'SET_PLCC_BANNER_HTML';
export const GET_PLCC_DETAILS_HTML = 'GET_PLCC_DETAILS_HTML';
export const SET_PLCC_DETAILS_HTML = 'SET_PLCC_DETAILS_HTML';
export const SET_PLCC_DYNAMIC_BANNER = 'SET_PLCC_DYNAMIC_BANNER';
export const SET_PLCC_SLIDER_OPEN = 'SET_PLCC_SLIDER_OPEN';
